import { render, staticRenderFns } from "./UniqueTrainer.vue?vue&type=template&id=0fd95dec"
import script from "./UniqueTrainer.vue?vue&type=script&lang=js"
export * from "./UniqueTrainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports